export default __webpack_public_path__ + "static/media/logo.3967bba7.svg";